import vue from 'vue'
import showToast from './msg'

// 全局注册
function registryToast() {
	vue.prototype.$msg = showToast
}

export default registryToast
